<template>
  <div>
    <div class="fixed-drawer-header-2 px-2">
      <v-btn-toggle width="100%" class="py-2 d-flex justify-between" v-model="conversationAdresseeToggle" mandatory>
        <v-btn value="conversation" class="d-flex" style="width: 50%">
          {{ $t('module.messaging.conversations') }}
        </v-btn>
        <v-btn value="receiver" class="d-flex" style="width: 50%">
          {{ $t('module.messaging.receiver') }}
        </v-btn>
      </v-btn-toggle>
      <v-text-field v-model="search" label="Suchen oder neuen Chat beginnen" filled rounded dense color="accent" clearable></v-text-field>
    </div>

    <div class="fixed-drawer-content-2" ref="fixedDrawerContent">
      <v-list dense>
        <div>
          <!--filteredReceivers-->
          <template v-if="conversationAdresseeToggle === 'receiver'">
            <v-virtual-scroll :height="fixedDrawerContentHeight" :items="receivers" :item-height="55">
              <template v-slot="{ item, ind }">
                <receiver
                  :receiver="item"
                  :selectedReceiver="selectedReceiver"
                  :index="ind"
                  @displayGroupMembers="displayGroupMembers"
                  @onSetSelectedReceiver="onSetSelectedReceiver"
                ></receiver>
              </template>
            </v-virtual-scroll>
          </template>

          <!-- chats -->
          <v-virtual-scroll v-else-if="chats" :items="chats" :item-height="80">
            <template v-slot="{ item, ind }">
              <v-list-item :class="isSelectedReceiver(item) ? 'selectedListItemColor' : ''" selectable @click="setSelectedReceiver(item, ind)">
                <v-list-item-icon class="align-self-center">
                  <v-icon>mdi-{{ item.groupId ? 'account-group' : 'account-circle' }}</v-icon>
                  <number-badge
                    style="position: absolute"
                    v-if="item.unreadMessagesCount > 0"
                    :offsetX="16"
                    :badge-color="theme.unreadBadgeColor"
                    :count="item.unreadMessagesCount"
                  ></number-badge>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="d-flex">
                    <div>{{ item.name }}</div>
                    <div v-if="!item.groupId && item.online && onlineDisplayIsEnabled" class="green online"></div>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.lastMessage" class="d-flex"
                    ><span>{{ item.lastMessage }}</span>
                    <span v-if="isReadStateApplicable(item.lastMsg)">
                      <span v-if="isReadByReceiver(item.lastMsg)" class="ml-1"><v-icon small color="success">mdi-check-all</v-icon></span>
                      <span v-else-if="isReceivedConfirmed(item.lastMsg)" class="ml-1"><v-icon small color="success">mdi-check</v-icon></span>
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="caption">{{ getLastMessageDate(item) }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item v-if="item.groupId" link @click="displayGroupMembers(item)">
                        <v-list-item-title>{{ $t('messaging.groupMembers') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="displayDeleteChatDialog(item, ind)">
                        <v-list-item-title> {{ $t('messaging.deleteWholeChat') }} </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-virtual-scroll>

          <!-- <div v-else-if="receivers && receivers.length === 0" class="px-5 text-wrap">
            Keine definierten Empfänger gefunden. Messaging Benutzer und Gruppen müssen im Cockpit als solche definiert
            werden
          </div> -->
        </div>
      </v-list>
    </div>
    <delete-chat-confirmation-dialog
      v-model="deleteChatConfirmationDialog"
      :receiver="deleteChatReceiver"
      :receiverIndex="selectedReceiverIndex"
      @deleteChatConfirmed="deleteChatConfirmed"
    ></delete-chat-confirmation-dialog>
    <group-member-dialog v-model="dialog" :dialogTitle="dialogTitle" :groupMembers="groupMembers"></group-member-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import NumberBadge from '@/components/decorators/NumberBadge.vue';
import messagingUtil from './messagingUtil';
import GroupMemberDialog from './GroupMemberDialog.vue';
import Receiver from './Receiver.vue';
import DeleteChatConfirmationDialog from './DeleteChatConfirmationDialog.vue';
import dateUtils from '@/common/dateUtils';

export default {
  components: { Receiver, NumberBadge, GroupMemberDialog, DeleteChatConfirmationDialog },
  mixins: [common, configMixin],
  name: 'MessagingDrawer',
  mounted() {
    this.selectFirstReceiver();
  },
  props: {
    displayConversations: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: '',
      dialog: false,
      deleteChatConfirmationDialog: false,
      dialogTitle: '',
      groupMembers: [],
      deleteChatReceiver: null,
      //selectedReceiver: null,
      selectedReceiverIndex: null,
      conversationAdresseeToggle: this.displayConversations ? 'conversations' : 'receiver',
    };
  },

  computed: {
    ...mapState('messaging', [
      'userId',
      'userById',
      'messages',
      'messagesByUserId',
      'messagesByGroupId',
      'messagesByUserIdUnreadCount',
      'messagesByGroupIdUnreadCount',
      'groupById',
      'dataLoaded',
      'users',
      'groups',
    ]),
    onlineDisplayIsEnabled() {
      let stage = this.$store.state.configs.stage;
      return this.features[`enableDisplayOfOnlineStateInMessaging_${stage}`] || false;
    },
    fixedDrawerContentHeight() {
      let height = 700;
      let el = this.$refs['fixedDrawerContent'];
      if (el) {
        height = el.getBoundingClientRect().height;
        console.debug('calculated height', height);
      }
      return height;
    },
    /**
     * Collects receivers (person and groups) with messages and sorts by
     * Person with messages
     * Groups with messages
     * Persons without messages
     * Groups without messages
     *
     * Filtered by search term
     */
    chats() {
      if (!this.dataLoaded) return null;
      let {
        search,
        userId,
        messagesByGroupId,
        messagesByUserId,
        messagesByGroupIdUnreadCount,
        messagesByUserIdUnreadCount,
        groupById,
        users,
        userById,
        groups,
      } = this;
      return messagingUtil.filterAndSortUsersAndGroups({
        skipCurrentUser: false,
        $t: this.$t,
        search,
        userId,
        messagesByGroupId,
        messagesByUserId,
        messagesByGroupIdUnreadCount,
        messagesByUserIdUnreadCount,
        groupById,
        users,
        userById,
        groups,
        dataLoaded: this.dataLoaded,
      });
    },
    /**
     * Collects receivers (person and groups) and sorts by
     * Person with messages
     * Groups with messages
     * Persons without messages
     * Groups without messages
     *
     * Filtered by search term
     */
    receivers() {
      if (!this.dataLoaded || this.conversationAdresseeToggle === 'conversation') return [];
      let { search, userId, messagesByGroupId, messagesByUserId, groupById, users, groups } = this;

      let receivers = messagingUtil.filteredReceivers({
        skipCurrentUser: true,
        $t: this.$t,
        search,
        userId,
        messagesByGroupId,
        messagesByUserId,
        groupById,
        users,
        groups,
        dataLoaded: this.dataLoaded,
      });
      return receivers;
    },
    selectedItemColor() {
      return this.theme.selectedItemColor;
    },
    selectedReceiver: {
      // getter
      get() {
        return this.$store.state.messaging.selectedReceiver;
      },
      // setter
      set(value) {
        this.$store.commit('messaging/setSelectedReceiver', value);
      },
    },
  },
  methods: {
    ...mapActions('messaging', ['deleteChat']),
    isReadStateApplicable(lastMessage) {
      let m = lastMessage;
      if (m?.isGroup === 1) return false;
      return m?.senderIdFk === this.userId;
    },
    isReceivedConfirmed(lastMessage) {
      return !!lastMessage.datereceived;
    },

    isReadByReceiver(lastMessage) {
      let m = lastMessage;
      if (m?.isGroup === 1) return null;
      return m?.dateread && m?.userIdFk === m?.receiverIdFk;
    },
    displayGroupMembers(receiver) {
      if (receiver && receiver.groupId) {
        this.dialog = true;
        this.dialogTitle = this.$t('messaging.groupMembers');
        let group = this.groupById[receiver.groupId];

        if (group) {
          this.groupMembers = group.users
            .filter((userId) => this.userById[userId] && userId !== this.userId)
            .map((userId) => this.userById[userId])

            .map((user) => {
              return {
                ...user,
                name: user ? `${messagingUtil.getNameFromUserObject(user)}` : user.id,
              };
            })

            .sort((a, b) => (!a.name ? 1 : a.name.localeCompare(b.name)))
            .concat({ name: this.$t('You') });
          console.debug(' this.groupMembers', this.groupMembers);
        }
      }
    },
    displayDeleteChatDialog(receiver, ind) {
      this.deleteChatReceiver = receiver;
      this.deleteChatConfirmationDialog = true;
      this.selectedReceiverIndex = ind;
    },
    deleteChatConfirmed(receiver) {
      console.debug('deleteChatConfirmed', receiver);
      this.deleteChat(receiver);
    },
    getLastMessageDate(receiver) {
      if (receiver.lastMsgDate) {
        return dateUtils.formatDateTime(new Date(receiver.lastMsgDate));
      }
      return null;
    },
    isSelectedReceiver(receiver) {
      return (
        this.selectedReceiver &&
        ((this.selectedReceiver.userId && this.selectedReceiver.userId === receiver.userId) ||
          (this.selectedReceiver.groupId && this.selectedReceiver.groupId === receiver.groupId))
      );
    },
    setSelectedReceiver(receiver, index) {
      if (
        this.selectedReceiver &&
        ((this.selectedReceiver.userId && this.selectedReceiver.userId === receiver.userId) ||
          (this.selectedReceiver.groupId && this.selectedReceiver.groupId === receiver.groupId))
      ) {
        console.debug('receiver already selected. Ignore setSelectedReceiver, but close drawer');
        this.mx_isLeftDrawerOpen = false;
        return;
      }
      this.selectedReceiver = receiver;
      this.selectedReceiverIndex = index;
      this.$emit('onReceiverSelected', receiver);
    },
    onSetSelectedReceiver({ receiver, ind }) {
      this.setSelectedReceiver(receiver, ind);
    },
    selectFirstReceiver() {
      console.debug(' ');
      // if (this.receivers) {
      //   this.setSelectedReceiver(this.receivers[0], 0);
      // }
    },
  },
  watch: {
    conversationAdresseeToggle(newValue) {
      console.debug('conversationAdresseeToggle', newValue);
      this.search = '';
    },
    receivers(newValue, oldValue) {
      const isChanged = JSON.stringify(newValue) !== JSON.stringify(oldValue);
      console.debug('receivers changed?', isChanged);
      if (isChanged && newValue && !this.selectedReceiver) {
        this.$nextTick(() => {
          this.selectFirstReceiver();
        });
      }
    },
  },
};
</script>
<style scoped>
.online {
  margin-left: 8px;
  width: 10px;
  height: 10px;
  border-radius: 4px;
}
</style>
